// @flow

function truncateToWord(str: string, length: number): string {
  if (str.length <= length) return str;
  const truncated = str.substring(0, length);
  return `${truncated.substring(0, truncated.lastIndexOf(' '))} ...`;
}

export default truncateToWord;
